<template>
  <span
    v-if="discount"
    class="label label--sale"
  >-{{ discount }}%</span>
</template>

<script setup lang="ts">
const props = defineProps<{
  prices: {
    finalPrice?: string | number
    regularPrice: string | number
  }
}>()

const discount = computed(() => {
  if (!props.prices.finalPrice || !props.prices.regularPrice || props.prices.finalPrice === props.prices.regularPrice) {
    return
  }

  return Math.ceil((1 - +props.prices.finalPrice / +props.prices.regularPrice) * 100)
})
</script>

<style>
@import url("~layers/app/components/Product/Labels.css");
</style>
